import { normalizeApiPath } from '@/lib/routing/platform-hosts';

function isAbsoluteUrl(path: string): boolean {
  return /^https?:\/\//i.test(path);
}

/**
 * Resolves an API path to a URL string suitable for fetch().
 *
 * Since all surfaces now run on the same origin (no subdomain routing),
 * this simply normalises the path , no cross-origin logic needed.
 *
 * Absolute URLs (e.g. third-party webhooks) are returned as-is.
 */
export function resolveApiRequestUrl(path: string): string {
  if (isAbsoluteUrl(path)) {
    return path;
  }
  return normalizeApiPath(path);
}